import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import { BOX_SHADOW } from 'src/vars';

// Tooltip component using tippyjs library
// Children needs to be wrapped in a span in order to work properly

const TooltipTippy = styled(Tippy)`
    padding: 10px;
    border-radius: 8px;
    background: var(--surface);
    box-shadow: ${BOX_SHADOW};
    color: var(--text-primary);

    .tippy-arrow {
        color: var(--surface);
    }
`;

const ToolTipContent = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
`;

export default function Tooltip({ content, arrow, placement, children, maxWidth, trigger }) {
    return (
        <TooltipTippy
            appendTo={document.body}
            arrow={arrow}
            delay={[0, 0]}
            placement={placement}
            interactive
            maxWidth={maxWidth}
            content={content}
            trigger={trigger}
        >
            <ToolTipContent>{children}</ToolTipContent>
        </TooltipTippy>
    );
}

Tooltip.propTypes = {
    content: PropTypes.string.isRequired,
    arrow: PropTypes.bool,
    placement: PropTypes.string,
    children: PropTypes.node.isRequired,
    maxWidth: PropTypes.string,
    trigger: PropTypes.string,
};

Tooltip.defaultProps = {
    arrow: false,
    placement: 'right',
    maxWidth: '350px',
    trigger: 'mouseenter focus',
};
